$(document).ready(function() {
                               $('#qqsubmit').click(function(){
                             
                                               
   var qqname = $('#qqname').val();
var qqemail = $('#qqemail').val();
var qqphone = $('#qqphone').val();
var qqmessage = $('#qqmessage').val();
                                var qqtelusproject = $('#qqtelusproject').val();

               
                               
                              if(qqemail==''){
                               $('#qqemail').css('border-color', 'red');

                                 return false;
                               }
                               else{
                                   
                                   var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
                                   if (testEmail.test(qqemail)){ $('#qqemail').css('border', '1px solid #ccc'); }
                                   else{  $('#qqemail').css('border-color', 'red'); return false; }
                               }
                              if(qqphone==''){
                               $('#qqphone').css('border-color', 'red');

                                 return false;
                               }
                                else{
                                 $('#qqphone').css('border', '1px solid #ccc');
                               }
                             
                              if(qqmessage==''){
                              $('#qqmessage').css('border-color', 'red');

                                 return false;
                               }
                                else{
                                  $('#qqmessage').css('border', '1px solid #ccc');
                                 
                               }
                                if(qqtelusproject==''){
                              $('#qqtelusproject').css('border-color', 'red');

                                 return false;
                               }
                                else{
                                  $('#qqtelusproject').css('border', '1px solid #ccc');
                                 
                               }
                                //$('#qqloader').text('mail send successfully');
                               // $('#qqloader').show();

                                 $.ajax({
        url: 'https://nncapp.com/siraj-request-quick-quote/mailer.php',
data: 'qqname=' + qqname + '&qqemail=' + qqemail + '&qqphone=' + qqphone + '&qqmessage=' + qqmessage + '&qqtelusproject=' + qqtelusproject,
        type: 'GET',
        contentType: false,
        dataType: 'text',
        processData:false,
         success: function(data){
          const url = new URL(window.location);
url.searchParams.set('submit', 'success');
window.history.pushState({}, '', url);
           $('#qqloader').hide();
          $('#quote-submit-popup').show();
           $('#qqname').val('');
           $('#qqemail').val('');
           $('#qqphone').val('');
           $('#qqmessage').val('');
           $('#qqtelusproject').val('');
           
         
           $('#qqinfo').text('Quote Submitted!');
          setTimeout(function(){ $('#quote-submit-popup').hide();  }, 3000);
          $('#qqinfo').click(function(){
            $(this).parent('.quote-submit-popup').hide();
          });
        },
      error:function(jqXHR,textStatus,errorThrown)
    {
  $('#qqloader').hide();
    $('#qqname').val('');
    $('#qqemail').val('');
    $('#qqphone').val('');
    $('#qqmessage').val('');
   
 

   }
    });

                         
                                 });
     $('#sqqsubmit').click(function(){
                             
                                               
   var sqqname = $('#sqqname').val();
var sqqemail = $('#sqqemail').val();
var sqqphone = $('#sqqphone').val();
var sqqmessage = $('#sqqmessage').val();
                                var sqqtelusproject = $('#sqqtelusproject').val();

                              if(sqqemail==''){
                               $('#sqqemail').css('border-color', 'red');

                                 return false;
                               }
                               else{
                                   
                                   var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
                                   if (testEmail.test(sqqemail)){ $('#sqqemail').css('border', '1px solid #ccc'); }
                                   else{  $('#sqqemail').css('border-color', 'red'); return false; }
                               }
                              if(sqqphone==''){
                               $('#sqqphone').css('border-color', 'red');

                                 return false;
                               }
                                else{
                                 $('#sqqphone').css('border', '1px solid #ccc');
                               }
                             
                              if(sqqmessage==''){
                              $('#sqqmessage').css('border-color', 'red');

                                 return false;
                               }
                                else{
                                  $('#sqqmessage').css('border', '1px solid #ccc');
                                 
                               }
    if(sqqtelusproject==''){
                              $('#sqqtelusproject').css('border-color', 'red');

                                 return false;
                               }
                                else{
                                  $('#sqqtelusproject').css('border', '1px solid #ccc');
                                 
                               }
                                //$('#sqqloader').text('mail send successfully');
                               // $('#sqqloader').show();

                                 $.ajax({
        url: 'https://nncapp.com/siraj-request-quick-quote/mailer.php',
data: 'qqname=' + sqqname + '&qqemail=' + sqqemail + '&qqphone=' + sqqphone + '&qqmessage=' + sqqmessage + '&qqtelusproject=' + sqqtelusproject,
        type: 'GET',
        contentType: false,
        dataType: 'text',
        processData:false,
         success: function(data){
          const url = new URL(window.location);
url.searchParams.set('submit', 'success');
window.history.pushState({}, '', url);
           $('#sqqloader').hide();
           $('#squote-submit-popup').show();
           $('#sqqname').val('');
           $('#sqqemail').val('');
           $('#sqqphone').val('');
           $('#sqqmessage').val('');
           $('#sqqtelusproject').val('');
           $('#sqqinfo').text('Quote Submitted!');
           setTimeout(function(){ $('#squote-submit-popup').hide();  }, 3000);
          $('#qqinfo').click(function(){
            $(this).parent('.quote-submit-popup').hide();
          });
        },
      error:function(jqXHR,textStatus,errorThrown)
    {
  $('#sqqloader').hide();
    $('#sqqname').val('');
    $('#sqqemail').val('');
    $('#sqqphone').val('');
    $('#sqqmessage').val('');
   
 

   }
    });

                         
                                 });                          
                               
                               
                                });